import { useMemo } from 'react';
import { KTSVG } from '../../../../../../../_metronic/helpers';
import { useDOCLabelFormView } from './components/DOCLabelFormContextProvider'


const DOCLabelRequestModalHeader = () => {

    const { initValues, cancelForm} = useDOCLabelFormView();
    const { requestId, appType, cocNumber, product, productBrand } = initValues;

    const label_type = useMemo(() => {
        switch(appType) {
            case 'DOC':
                return 'DOC';
            case 'MandatoryDOC':
                return 'DOC with Mandatory Inspection';
                
            case 'Label5':
                return 'Label (Scheme 5)';
            case 'Label1b1':
                return 'Label (Scheme 1b) - 1 Loop';
            case 'Label1b2':
                return 'Label (Scheme 1b) - 2 Loop';
            case 'Label1b3':
                return 'Label (Scheme 1b) - 3 Loop';
            
            case 'SiteInspect':
                return 'Site Inspection';
            case 'LabelInspect':
                return 'Label Inspection'
            case 'TriggerTest':
                return 'Trigger Test';
            
            default:
                return appType;
        }

    }, [appType])

    return (
    <div className='modal-header'>
        <div className='flex-grow-1'>
            <h2 className='fw-bolder'>{label_type} Request</h2>
            <div className="d-flex flex-row flex-wrap align-items-center gap-6 p-2">                
                <div className="d-flex flex-row flex-center gap-2">
                    <label className='fw-bold text-muted fs-7'>Application No: </label>
                    <div className="className='fw-bolder fs-7 text-dark">{(requestId && requestId > 0) ? requestId : 'NEW'}</div>
                </div>                
                <div className="d-flex flex-row flex-center gap-2">
                    <label className='fw-bold text-muted fs-7'>COC No: </label>
                    <div className="className='fw-bolder fs-7 text-dark">{cocNumber}</div>
                </div>
                <div className="d-flex flex-row flex-center gap-2">
                    <label className='fw-bold text-muted fs-7'>Product: </label>
                    <div className="className='fw-bolder fs-7 text-dark">{product}</div>
                </div>
                <div className="d-flex flex-row flex-center gap-2">
                    <label className='fw-bold text-muted fs-7'>Brand: </label>
                    <div className="className='fw-bolder fs-7 text-dark">{productBrand}</div>
                </div>
            </div>
        </div>
        <div
            className='btn btn-icon btn-sm btn-active-icon-primary btn-close align-self-start'
            data-kt-certificates-modal-action='close'
            style={{cursor: 'pointer'}}
            onClick={() => {
                cancelForm();
            }}
        >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
        </div>
    </div>
    )
}

export {DOCLabelRequestModalHeader}
